"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForMainMenuCharacterSelectUpdates = void 0;
const MainMenuCharacter_1 = require("../../../classes/MainMenuCharacter");
const pixel_pigeon_1 = require("pixel-pigeon");
const definables_1 = require("definables");
const getLastPlayableCharacterIndex_1 = require("../../getLastPlayableCharacterIndex");
const getMainMenuCharacterSelectState_1 = require("../../state/main-menu/getMainMenuCharacterSelectState");
const getMainMenuState_1 = require("../../state/main-menu/getMainMenuState");
const constants_1 = require("../../../constants");
const listenForMainMenuCharacterSelectUpdates = () => {
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "main-menu/character-select/delete-character",
        onMessage: (update) => {
            const mainMenuState = (0, getMainMenuState_1.getMainMenuState)();
            const characterSelectState = (0, getMainMenuCharacterSelectState_1.getMainMenuCharacterSelectState)();
            const character = (0, definables_1.getDefinable)(MainMenuCharacter_1.MainMenuCharacter, update.mainMenuCharacterID);
            character.remove();
            const mainMenuCharacterIDs = mainMenuState.values.mainMenuCharacterIDs.filter((mainMenuCharacterID) => mainMenuCharacterID !== update.mainMenuCharacterID);
            const thresholdCharactersAmount = characterSelectState.values.page * constants_1.mainMenuCharactersPerPage;
            const page = Math.max(mainMenuCharacterIDs.length <= thresholdCharactersAmount
                ? characterSelectState.values.page - 1
                : characterSelectState.values.page, 0);
            characterSelectState.setValues({
                isDeleting: false,
                mainMenuCharacterIDToDelete: null,
                page,
            });
            mainMenuState.setValues({
                mainMenuCharacterIDs,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "main-menu/character-select/sort-character-left",
        onMessage: (update) => {
            const mainMenuState = (0, getMainMenuState_1.getMainMenuState)();
            const characterIndex = mainMenuState.values.mainMenuCharacterIDs.indexOf(update.mainMenuCharacterID);
            const targetIndex = characterIndex === 0
                ? (0, getLastPlayableCharacterIndex_1.getLastPlayableCharacterIndex)()
                : characterIndex - 1;
            const targetCharacterID = mainMenuState.values.mainMenuCharacterIDs[targetIndex];
            if (typeof targetCharacterID === "undefined") {
                throw new Error("Out of bounds character IDs index");
            }
            const mainMenuCharacterIDs = [
                ...mainMenuState.values.mainMenuCharacterIDs,
            ];
            mainMenuCharacterIDs[targetIndex] = update.mainMenuCharacterID;
            mainMenuCharacterIDs[characterIndex] = targetCharacterID;
            mainMenuState.setValues({ mainMenuCharacterIDs });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "main-menu/character-select/sort-character-right",
        onMessage: (update) => {
            const mainMenuState = (0, getMainMenuState_1.getMainMenuState)();
            const characterIndex = mainMenuState.values.mainMenuCharacterIDs.indexOf(update.mainMenuCharacterID);
            const targetIndex = characterIndex === (0, getLastPlayableCharacterIndex_1.getLastPlayableCharacterIndex)()
                ? 0
                : characterIndex + 1;
            const targetCharacterID = mainMenuState.values.mainMenuCharacterIDs[targetIndex];
            if (typeof targetCharacterID === "undefined") {
                throw new Error("Out of bounds character IDs index");
            }
            const mainMenuCharacterIDs = [
                ...mainMenuState.values.mainMenuCharacterIDs,
            ];
            mainMenuCharacterIDs[targetIndex] = update.mainMenuCharacterID;
            mainMenuCharacterIDs[characterIndex] = targetCharacterID;
            mainMenuState.setValues({ mainMenuCharacterIDs });
        },
    });
};
exports.listenForMainMenuCharacterSelectUpdates = listenForMainMenuCharacterSelectUpdates;
